import accessTimeOutlined from './AccessTimeOutlined.svg';
import accessTimeOutlinedGrey from './AccessTimeOutlinedGrey.svg';
import accessTimeOutlinedWhite from './AccessTimeOutlinedWhite.svg';
import addOutlined from './AddOutlined.svg';
import arrowBackIosNewOutlined  from './ArrowBackIosNewOutlined.svg';
import arrowBackIosNewOutlinedWhite  from './ArrowBackIosNewOutlinedWhite.svg';
import battery0BarOutlined  from './Battery0BarOutlined.svg';
import batteryCharging20Outlined  from './BatteryCharging20Outlined.svg';
import busAlertOutlinedGrey  from './BusAlertOutlined-grey.svg';
import busAlertOutlined3  from './BusAlertOutlined-3.svg';
import busAlertOutlined4  from './BusAlertOutlined-4.svg';
import busAlertOutlinedWhite  from './BusAlertOutlined-white.svg';
import clearOutlinedBlack from './ClearOutlinedBlack.svg';
import clearOutlinedGrey from './ClearOutlinedGrey.svg';
import clearOutlinedWhite from './ClearOutlinedWhite.svg';
import chargingStationOutlined from './ChargingStationOutlined.svg';
import chargingStationOutlinedWhite from './ChargingStationOutlinedWhite.svg';
import checkOutlined from './CheckOutlined.svg';
import constructionOutlined from './ConstructionOutlined.svg';
import constructionOutlinedGrey from './ConstructionOutlinedGrey.svg';
import contentCopyOutlined from './ContentCopyOutlined.svg';
import contentCopyOutlinedBlue from './ContentCopyOutlinedBlue.svg';
import corporateFareOutlinedWhite from './CorporateFareOutlinedWhite.svg';
import dateRangeOutlined from './DateRangeOutlined.svg';
import deleteForeverOutlined from './DeleteForeverOutlined.svg';
import deleteForeverOutlinedBlue from './DeleteForeverOutlinedBlue.svg';
import deleteForeverOutlinedBlack from './DeleteForeverOutlinedBlue.svg';
import directionsBusFilledOutlined from './DirectionsBusFilledOutlined.svg';
import directionsBusFilledOutlinedBlue from './DirectionsBusFilledOutlinedBlue.svg';
import directionsBusFilledOutlinedGrey from './DirectionsBusFilledOutlinedGrey.svg';
import directionsBusFilledOutlinedWhite from './DirectionsBusFilledOutlinedWhite.svg';
import doNotDisturbOutlined from './DoNotDisturbOutlined.svg';
import editOutlined from './EditOutlined.svg';
import editOutlinedBlue from './EditOutlinedBlue.svg';
import emailOutlined from './EmailOutlined.svg';
import emailOutlinedBlue from './EmailOutlinedBlue.svg';
import emailOutlinedWhite from './EmailOutlinedWhite.svg';
import evStationOutlined from './EvStationOutlined.svg';
import evStationOutlinedWhite from './EvStationOutlinedWhite.svg';
import expandCircleDownOutlined from './ExpandCircleDownOutlined.svg';
import expandMoreOutlined from './ExpandMoreOutlined.svg';
import fileDownloadOutlined from './FileDownloadOutlined.svg';
import fileDownloadOutlinedWhite from './FileDownloadOutlinedWhite.svg';
import filter from './filter.svg';
import headerCircle from './headerCircle.svg';
import infoOutlined from './InfoOutlined.svg';
import infoOutlinedWhite from './InfoOutlinedWhite.svg';
import infoOutlinedBlue from './InfoOutlinedBlue.svg';
import localParkingOutlined from './LocalParkingOutlined.svg';
import localParkingOutlinedWhite from './LocalParkingOutlinedWhite.svg';
import lockOutlined from './LockOutlined.svg';
import logoutOutlined from './LogoutOutlined.svg';
import loupeOutlined from './LoupeOutlined.svg';
import loupeOutlinedBlue from './LoupeOutlinedBlue.svg';
import loupeOutlinedWhite from './LoupeOutlinedWhite.svg';
import mapOutlined from './MapOutlined.svg';
import mapOutlinedWhite from './MapOutlinedWhite.svg';
import noTransferOutlined from './NoTransferOutlined.svg';
import noTransferOutlinedWhite from './NoTransferOutlinedWhite.svg';
import permIdentityOutlined from './PermIdentityOutlined.svg';
import placeOutlined from './PlaceOutlined.svg';
import placeOutlinedWhite from './PlaceOutlinedWhite.svg';
import playCircleOutlineOutlined from './PlayCircleOutlineOutlined.svg';
import playCircleOutlineOutlinedWhite from './PlayCircleOutlineOutlinedWhite.svg';
import powerSettingsNewOutlined from './PowerSettingsNewOutlined.svg';
import removeOutlined from './RemoveOutlined.svg';
import searchOutlined from './SearchOutlined.svg';
import searchOutlinedGrey from './SearchOutlinedGrey.svg';
import settingsOutlined from './SettingsOutlined.svg';
import settingsOutlinedGrey from './SettingsOutlinedGrey.svg';
import shareOutlined from './ShareOutlined.svg';
import shareOutlinedWhite from './ShareOutlinedWhite.svg';
import starBorderOutlined from './StarBorderOutlined.svg';
import storefrontOutlined from './StorefrontOutlined.svg';
import storefrontOutlinedWhite from './StorefrontOutlinedWhite.svg';
import unfoldMoreOutlined from './UnfoldMoreOutlined.svg';
import verifiedOutlined from './VerifiedOutlined.svg';
import verifiedOutlinedBlue from './VerifiedOutlinedBlue.svg';
import verifiedOutlinedGrey from './VerifiedOutlinedGrey.svg';
import viewBus from './viewBus.svg';
import viewBusBlue from './viewBusBlue.svg';
import viewBusWhite from './viewBusWhite.svg';
import visibilityOffOutlined from './VisibilityOffOutlined.svg';
import visibilityOutlined from './VisibilityOutlined.svg';
import visibilityOutlinedBlack from './VisibilityOutlinedBlack.svg';
import visibilityOutlinedBlue from './VisibilityOutlinedBlue.svg';
import visibilityOutlinedWhite from './VisibilityOutlinedWhite.svg';
import warehouseOutlined from './WarehouseOutlined.svg';
import warehouseOutlinedWhite from './WarehouseOutlinedWhite.svg';
import warehouseOutlined1 from './WarehouseOutlined-1.svg';
import warningAmberOutlined from './WarningAmberOutlined.svg';
import warningAmberOutlinedRed from './WarningAmberOutlinedRed.svg';



export {
    accessTimeOutlined,
    accessTimeOutlinedGrey,
    accessTimeOutlinedWhite,
    addOutlined,
    arrowBackIosNewOutlined,
    arrowBackIosNewOutlinedWhite,
    battery0BarOutlined,
    batteryCharging20Outlined,
    busAlertOutlinedGrey,
    busAlertOutlined3,
    busAlertOutlined4,
    busAlertOutlinedWhite,
    clearOutlinedBlack,
    clearOutlinedGrey,
    clearOutlinedWhite,
    chargingStationOutlined,
    chargingStationOutlinedWhite,
    checkOutlined,
    constructionOutlined,
    constructionOutlinedGrey,
    contentCopyOutlined,
    contentCopyOutlinedBlue,
    corporateFareOutlinedWhite,
    dateRangeOutlined,
    deleteForeverOutlined,
    deleteForeverOutlinedBlue,
    deleteForeverOutlinedBlack,
    directionsBusFilledOutlined,
    directionsBusFilledOutlinedBlue,
    directionsBusFilledOutlinedGrey,
    directionsBusFilledOutlinedWhite,
    doNotDisturbOutlined,
    editOutlined,
    editOutlinedBlue,
    emailOutlined,
    emailOutlinedBlue,
    emailOutlinedWhite,
    evStationOutlined,
    evStationOutlinedWhite,
    expandCircleDownOutlined,
    expandMoreOutlined,
    fileDownloadOutlined,
    fileDownloadOutlinedWhite,
    filter,
    headerCircle,
    infoOutlined,
    infoOutlinedWhite,
    infoOutlinedBlue,
    localParkingOutlined,
    localParkingOutlinedWhite,
    lockOutlined,
    logoutOutlined,
    loupeOutlined,
    loupeOutlinedBlue,
    loupeOutlinedWhite,
    mapOutlined,
    mapOutlinedWhite,
    noTransferOutlined,
    noTransferOutlinedWhite,
    permIdentityOutlined,
    placeOutlined,
    placeOutlinedWhite,
    playCircleOutlineOutlined,
    playCircleOutlineOutlinedWhite,
    powerSettingsNewOutlined,
    removeOutlined,
    searchOutlined,
    searchOutlinedGrey,
    settingsOutlined,
    settingsOutlinedGrey,
    shareOutlined,
    shareOutlinedWhite,
    starBorderOutlined,
    storefrontOutlined,
    storefrontOutlinedWhite,
    unfoldMoreOutlined,
    verifiedOutlined,
    verifiedOutlinedGrey,
    verifiedOutlinedBlue,
    viewBus,
    viewBusBlue,
    viewBusWhite,
    visibilityOffOutlined,
    visibilityOutlined,
    visibilityOutlinedBlack,
    visibilityOutlinedBlue,
    visibilityOutlinedWhite,
    warehouseOutlined,
    warehouseOutlinedWhite,
    warehouseOutlined1,
    warningAmberOutlined,
    warningAmberOutlinedRed
}